"use strict";
/* eslint-disable max-len, @typescript-eslint/prefer-for-of */
Object.defineProperty(exports, "__esModule", { value: true });
exports.regionPingMatrix = exports.RegionIndex = void 0;
exports.getRegionDelayMatrix = getRegionDelayMatrix;
exports.getRandomRegion = getRandomRegion;
// This file contains a 16x16 matrix of ping times measured between
// amazon regions. Converted to typescript from the file pings.csv
// in order to make loading into browser easier.
var RegionIndex;
(function (RegionIndex) {
    RegionIndex[RegionIndex["eu_central_1"] = 0] = "eu_central_1";
    RegionIndex[RegionIndex["eu_west_1"] = 1] = "eu_west_1";
    RegionIndex[RegionIndex["eu_west_2"] = 2] = "eu_west_2";
    RegionIndex[RegionIndex["eu_west_3"] = 3] = "eu_west_3";
    RegionIndex[RegionIndex["eu_north_1"] = 4] = "eu_north_1";
    RegionIndex[RegionIndex["us_east_1"] = 5] = "us_east_1";
    RegionIndex[RegionIndex["us_east_2"] = 6] = "us_east_2";
    RegionIndex[RegionIndex["us_west_1"] = 7] = "us_west_1";
    RegionIndex[RegionIndex["us_west_2"] = 8] = "us_west_2";
    RegionIndex[RegionIndex["ca_central_1"] = 9] = "ca_central_1";
    RegionIndex[RegionIndex["ap_south_1"] = 10] = "ap_south_1";
    RegionIndex[RegionIndex["ap_northeast_2"] = 11] = "ap_northeast_2";
    RegionIndex[RegionIndex["ap_southeast_1"] = 12] = "ap_southeast_1";
    RegionIndex[RegionIndex["ap_southeast_2"] = 13] = "ap_southeast_2";
    RegionIndex[RegionIndex["ap_northeast_1"] = 14] = "ap_northeast_1";
    RegionIndex[RegionIndex["sa_east_1"] = 15] = "sa_east_1";
})(RegionIndex || (exports.RegionIndex = RegionIndex = {}));
exports.regionPingMatrix = [
    [0.325, 23.163, 12.942, 8.923, 20.699, 89.208, 99.98, 150.077, 139.224, 90.454, 117.0, 226.823, 154.592, 286.753, 222.719, 205.563],
    [24.911, 0.195, 10.022, 18.544, 39.802, 66.161, 93.877, 136.271, 127.362, 73.733, 122.187, 229.064, 177.256, 254.277, 200.207, 186.817],
    [12.879, 9.994, 0.167, 8.626, 31.896, 74.663, 85.231, 136.185, 125.328, 77.811, 111.29, 236.34, 164.357, 262.577, 207.745, 187.383],
    [9.007, 16.823, 8.761, 0.191, 28.449, 81.969, 92.599, 140.961, 132.269, 85.444, 107.421, 243.981, 167.17, 279.322, 214.088, 197.986],
    [20.661, 40.0, 31.176, 27.645, 0.137, 104.171, 115.704, 165.01, 155.741, 107.635, 136.75, 267.321, 173.951, 292.266, 238.492, 216.048],
    [89.076, 67.701, 75.414, 81.598, 104.866, 0.284, 11.501, 61.662, 78.612, 14.115, 186.697, 174.546, 210.93, 196.071, 145.622, 114.919],
    [100.018, 93.968, 85.06, 92.582, 115.719, 11.514, 0.184, 51.668, 48.447, 25.808, 195.433, 160.031, 197.27, 186.913, 133.115, 127.954],
    [148.544, 137.18, 136.137, 141.333, 164.73, 60.257, 50.886, 0.197, 21.509, 77.668, 229.32, 134.858, 174.472, 137.329, 107.566, 175.944],
    [137.885, 128.304, 125.316, 132.271, 155.726, 63.376, 48.457, 20.743, 0.293, 59.645, 218.285, 126.988, 162.72, 138.599, 100.203, 174.612],
    [90.494, 78.203, 77.998, 84.348, 109.549, 14.136, 25.917, 77.323, 59.692, 0.163, 187.854, 169.253, 206.944, 195.467, 141.054, 126.962],
    [120.19, 119.978, 112.023, 107.434, 139.361, 185.043, 195.679, 233.008, 216.025, 186.888, 0.177, 130.21, 56.019, 145.643, 128.57, 298.98],
    [226.296, 229.187, 237.024, 243.839, 266.919, 174.727, 160.066, 136.623, 124.799, 169.854, 129.131, 0.189, 81.065, 139.967, 33.24, 284.578],
    [154.691, 178.279, 170.997, 154.261, 173.776, 211.511, 197.551, 173.735, 162.834, 206.659, 56.964, 68.853, 0.215, 91.601, 69.684, 323.146],
    [289.784, 253.234, 261.752, 277.504, 292.125, 198.099, 185.709, 136.413, 138.613, 194.986, 142.484, 147.706, 91.615, 0.156, 114.518, 311.12],
    [223.926, 201.084, 210.133, 216.779, 237.762, 145.336, 132.887, 108.26, 98.057, 142.613, 122.716, 33.185, 68.547, 114.901, 0.162, 257.403],
    [205.555, 178.082, 186.533, 195.774, 216.701, 117.089, 128.001, 175.761, 176.018, 125.551, 303.904, 285.782, 323.15, 309.618, 255.904, 0.262]
];
function getRegionDelayMatrix() {
    const ret = [];
    for (let i = 0; i < exports.regionPingMatrix.length; i++) {
        const row = [];
        for (let j = 0; j < exports.regionPingMatrix[i].length; j++) {
            row.push(exports.regionPingMatrix[i][j] / 2);
        }
        ret.push(row);
    }
    return ret;
}
function getRandomRegion() {
    return Math.floor(Math.random() * 15);
}
//# sourceMappingURL=pings.js.map